<template>
  <div
    class="act_wrap"
    :class="isException || !initLoaded ? 'wrap_exception' : 'bg'"
    v-r-loading="pageLoading"
  >
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="efoMoreHead.title"
        :transShow="transSHow"
        :transOpen="true"
        @icon-click="goBack"
      />
    </div>
    <EfocateSkeleton v-if="!initLoaded" />
    <div v-else class="act_box">
      <!-- back icon  -->
      <div
        class="back_btn"
        :class="isException ? 'exceptionColor' : ''"
        @click="goBack"
      >
        <i class="icon-linetype_back_iOS"></i>
      </div>
      <template v-if="isException">
        <EfoException :msg="exceptionMsg" :btnTitle="exceptionBtnTitle" />
      </template>
      <template v-else>
        <!-- banner -->
        <EfoActBanner :data="efoMoreHead" ref="BannerRef" />
        <!-- list -->
        <List
          btn-class="btn-efo-style"
          :auto-load="autoLoad"
          :distance="distance"
          :outline="false"
          :load-more-status="loadMoreStatus"
          @more="loadMore"
        >
          <div class="act_list_box">
            <EFOCateCard
              class="item-cate-card"
              :class="isH5 ? 'item_box_h5' : 'item_box_pc'"
              v-for="(item, index) in efoMoreItem"
              v-observer-log="item._logInfo_"
              :key="index + 'item'"
              type="notSimple"
              :valuedata="item"
              :wrap="
                fromIndexGetWrapStatus(efoCateBuyBtnWrap, {
                  index: index,
                  type: 'notSimple',
                })
              "
              @card-click="cardClick($event, { index: index })"
              @buy-click="buyClick($event, { index: index })"
              @update-wrap="setEfoCateBuyBtnWrap({ index: index, ...$event })"
            />
          </div>
        </List>
      </template>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import api from '@/api';

import Spec from '@/mixins/spec';
import List from '@/components/List';
import EFOCateCard from '@/components/EFOCateCard';
import EfoActBanner from '@/components/Efo/efoActBanner';
import EfoException from '@/components/Efo/efoException';
import PageMbHeader from '@/components/PageMbHeader';
import EfocateSkeleton from '@/components/SkeletonComponents/efocateSkeleton/efocateSkeleton.vue';

import EfoStrategy, { ALERT_TYPE } from '@/utils/efoStrategy';
import { CATE_SOURCE } from '@/const/dishfood';
import { LOG_SCENE_MAP } from '@/const/logs';

export default {
  components: {
    List,
    EfoActBanner,
    EFOCateCard,
    EfoException,
    PageMbHeader,
    EfocateSkeleton,
  },
  mixins: [Spec],
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      efoCateBuyBtnWrap: ({ act }) => act.efoCateBuyBtnWrap,
    }),
  },
  data() {
    return {
      initLoaded: false,
      componentId: this.$route.params.componentId,
      recId: '',
      pageLoading: false,
      titledistance: 88,
      transSHow: false,
      page: 0,
      distance: 60,
      autoLoad: true,
      loadMoreStatus: 'suc', // 加载状态 suc fail nomore loading

      isException: false, // 活动是否异常
      actStatus: 0, // [埋点]活动状态码
      exceptionMsg: '',
      exceptionBtnTitle: '',
      actData: {}, // 整体数据
      efoMoreItem: [], // 菜品数据
      efoMoreHead: {}, // 头部信息
      efoStrategy: {}, // 策略信息
    };
  },
  created() {
    this.pageLoading = true;
    this.loadMore().finally(() => {
      this.initLoaded = true;
      this.pageLoading = false;
    });
  },
  mounted() {
    this.bindScroll();
    this.bindPopstate();
  },
  destroyed() {
    this.unbindScroll();
    this.unbindPopstate();
  },
  methods: {
    ...mapMutations('act', ['setEfoCateBuyBtnWrap']),
    goBack() {
      this.$router.back();
    },
    async getData(param = {}) {
      const { page = 0, count = 20 } = param;
      if (param?.page === 0) {
        this.resetData();
      }
      const res = await api.apiGetEFOMore({
        page,
        count,
        recId: this.recId,
        componentId: this.componentId,
      });

      if (res) {
        this.setEfoActData(res, param?.page);
        this.page++;
        this.loadMoreStatus = !res?.hasMore ? 'nomore' : 'suc';
      } else {
        this.loadMoreStatus = 'fail';
      }
    },
    resetData() {
      this.efoActData = {};
      this.efoMoreItem = [];
      this.efoMoreHead = {};
      this.setEfoCateBuyBtnWrap({ clear: true });
    },
    setEfoActData(data, page) {
      const { layouts = [] } = data;
      const efoMoreItemArr = [];
      let efoMoreHead = {};

      layouts.forEach((layoutItem) => {
        const { cards = [] } = layoutItem || {};
        cards.forEach((cardItem) => {
          if (cardItem?.data?.efoMoreItem) {
            // 菜品数据
            efoMoreItemArr.push(cardItem.data.efoMoreItem);
          } else if (cardItem?.data?.efoMoreHead) {
            // 头部信息数据
            efoMoreHead = cardItem.data.efoMoreHead;
          } else if (cardItem?.data?.efoMoreException) {
            // 异常卡片
            const {
              desc = ' ',
              btn = {},
              actStatus,
            } = cardItem?.data?.efoMoreException;
            this.isException = true;
            this.exceptionMsg = desc;
            this.actStatus = actStatus;
            this.exceptionBtnTitle = btn.title;
          }
        });
      });

      // 曝光埋点
      const EfoMoreItemLength = this.efoMoreItem.length;

      efoMoreItemArr.forEach((item, i) => {
        item._logInfo_ = {
          eventId: 'sailing_c_x_top_item_realexposure_sw',
          eventLabel: '活动页EFO菜品曝光',
          attrs: {
            shop_id: item.shopId,
            item_id: item.itemId,
            item_status: 1,
            index: EfoMoreItemLength + i,
            from: 2,
            max_level: item.maxLevel,
            price: item.price,
            discount_price: item.specialPrice,
            scene: LOG_SCENE_MAP.efo,
            meta: {
              page: 'showAll',
              page_num: page,
              module: 'efo',
              inside_index: EfoMoreItemLength + i,
            },
          },
          tag: 'activity',
        };
      });

      this.efoActData = data;
      this.efoMoreItem.push(...efoMoreItemArr);

      if (page === 0) {
        this.recId = data.extra?.recId || '';
        this.efoMoreHead = efoMoreHead;
        // 页面曝光
        this.$trackEvent({
          eventId: 'sailing_c_x_top_second_common_sw',
          eventLabel: '二级活动页-页面浏览曝光',
          attrs: {
            rec_id: this.recId,
            page_type: this.actStatus,
            scene: LOG_SCENE_MAP.efo,
          },
        });
        // 获取挽留弹窗策略信息
        const strategy =
          data?.navi?.interactions?.[0]?.retainInfo?.strategy || {};
        const { cycle, num, uniqueId } = strategy;
        this.efoStrategy = { cycle, num, uniqueId };
        // 存储挽留弹窗策略信息
        if (uniqueId && cycle && num) {
          EfoStrategy.setStrategyInfo(this.efoStrategy);
        }
      }
    },
    loadMore() {
      this.page > 0 && (this.loadMoreStatus = 'loading');
      return this.getData({ page: this.page });
    },
    buyClick(item, payload) {
      this.mixinBtnClick(item, {
        source: CATE_SOURCE.EFO.name,
        from: 2,
        recId: this.recId,
        ...payload,
      });
    },
    cardClick(item, payload) {
      this.mixinCardClick(item, {
        source: CATE_SOURCE.EFO.name,
        from: 2,
        recId: this.recId,
        ...payload,
      });
    },
    startSpecAxios() {
      this.pageLoading = true;
    },
    endSpecAxios() {
      this.pageLoading = false;
    },
    startBtnClick() {
      this.unbindPopstate();
      this.$router.back();
    },
    bindScroll() {
      document.addEventListener('scroll', this.onScroll);
    },
    unbindScroll() {
      document.removeEventListener('scroll', this.onScroll);
    },
    onScroll(e) {
      let scrollTop =
        document?.documentElement?.scrollTop || document?.body?.scrollTop;
      if (scrollTop <= 0) return;
      this.transSHow = scrollTop > this.titledistance;
    },
    bindPopstate() {
      if (window.name !== this.$route?.name) {
        this.pushHistory();
        window.name = this.$route?.name;
      }
      window.addEventListener('popstate', this.getRetainStatus, {
        capture: false,
        passive: false,
        once: false,
      });
    },
    unbindPopstate() {
      window.removeEventListener('popstate', this.getRetainStatus);
    },
    retainFn(status) {
      // 考虑次数？？？
      if (!status) {
        this.pushHistory();
      } else {
        this.openBack();
      }
    },
    getRetainStatus() {
      const arrived_time = this.$refs['BannerRef']?.time || '';
      return EfoStrategy.getAlert(
        {
          arrived_time,
          type: ALERT_TYPE.STRATEGY,
          showLogInfo: {
            eventId: 'sailing_c_x_top_activity_quit_popup_sw',
            eventLabel: '活动页挽留弹窗展示',
            attrs: {
              rec_id: this.recId,
              scene: LOG_SCENE_MAP.efo,
            },
          },
        },
        (status, alertType) => {
          if (alertType !== 'NO_ALERT') {
            this.$trackEvent({
              eventId: 'sailing_c_x_operation_activity_quit_popup_ck',
              eventLabel: '活动页挽留弹窗按钮点击',
              attrs: {
                rec_id: this.recId,
                button_type: status ? 1 : 2,
                scene: LOG_SCENE_MAP.efo,
              },
            });
          }
          this.retainFn(status);
        }
      );
    },
    pushHistory() {
      window.history.pushState(null, null, document.URL);
    },
    openBack() {
      window.name = '';
      this.unbindPopstate();
      this.$router.back();
    },
  },
};
</script>
<style lang="scss">
.act_wrap .btn-efo-style {
  background: transparent !important;
}
</style>
<style lang="scss" scoped>
.act_wrap {
  width: 100%;
  min-height: 80vh;
  position: relative;
  &.bg {
    background-image: linear-gradient(270deg, #ff8b45 0%, #ff6a2e 99%);
  }
  &.wrap_exception {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.act_box {
  margin: 0 auto;
  width: 1156px;
}
.back_btn {
  position: absolute;
  top: 26px;
  left: 42px;
  width: 36px;
  height: 36px;
  font-size: 36px;
  color: #fff;
  cursor: pointer;
  // text-shadow: 2px 2px 2px rgba(0, 0, 0, 50%);
  &.exceptionColor {
    color: #000;
  }
}
.act_list_box {
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  .item_box_pc {
    flex-shrink: 0;
    width: 215px;
    margin-right: 20px;
    margin-bottom: 20px;
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
  }
  .act_box {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
  }
  .act_list_box {
    margin-left: rem(24);
    .item_box_h5 {
      width: rem(340);
      margin-right: rem(20);
      margin-bottom: rem(20);
    }
  }
  .back_btn {
    top: rem(32);
    left: rem(32);
    width: rem(48);
    height: rem(48);
    font-size: rem(48);
  }
}
</style>